import React from 'react';

import { Box, Typography } from '@mui/material';

import './StatementSection.scss';

const StatementSection = ({ title, children }) => {
    return (
        <Box className="statementSection">
            <Typography component="h1">{title}</Typography>
            {children}
        </Box>
    );
};

export default StatementSection;
